"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-gregorio-nelle-alpi": {
    "4000931c": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "skipSearch": false
    }],
    "alconis": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de6e7978": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "skipSearch": false
    }],
    "caval": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4199e966": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "skipSearch": false
    }],
    "donce": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e748a31a": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "skipSearch": false
    }],
    "saltoi": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d36a9c45": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "skipSearch": false
    }],
    "tassin": [{
      "hkey": "431746d9",
      "slug": "san-gregorio-nelle-alpi",
      "name": "San Gregorio nelle Alpi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;